import { all } from "redux-saga/effects";
import orgProfileSaga from "./orgProfileSaga";
import communicationSaga from "./communicationSaga";
import orgAccessSaga from "../features/orgAccess/orgAccessSaga";
import noteSettingsSaga from "../features/noteSettings/noteSettingsSaga";
import organisationProfileSaga from "../orgProfile/organisationProfileSaga";
import usersSaga from '../features/users/usersSaga';
import relationshipsSaga from '../features/relationships/relationshipsSaga';
import partiesSaga from '../features/parties/partiesSaga';

export default function* rootSaga() {
  yield all([...orgProfileSaga, partiesSaga(), communicationSaga(), orgAccessSaga(), noteSettingsSaga(), organisationProfileSaga(), usersSaga(), relationshipsSaga()]);
}
